<template>
  <div v-if="vacancyPage" id="applicant-edit-tab-job">
    <div class="flex">
      <p class="flex-grow text-xl font-medium text-gray-600">Übersicht</p>
      <router-link
        :to="{
          name: 'project.edit.sub.job',
          params: { page: 'jobs', jobid: 'create' }
        }"
      >
        <vs-button icon="fa-plus" icon-pack="fas"></vs-button>
      </router-link>
    </div>
    <div
      v-for="vacancy of vacancyPage.results"
      :key="vacancy.id"
      class="job-title py-5 border-solid border-t-0 border-r-0 border-l-0 border border-gray-100"
    >
      <router-link
        :to="{
          name: 'project.edit.sub.job',
          params: { page: 'jobs', jobid: vacancy.id }
        }"
      >
        <feather-icon icon="arrow-right" svg-classes="h-4 w-4" />
        {{ vacancy.number }}
        -
        {{ vacancy.title }}
      </router-link>
      <feather-icon icon="chevron-right" svg-classes="h-4 w-4" />
    </div>
    <vs-pagination
      v-model="currentPage"
      :total="totalPages"
      :max="5"
      icon-pack="fas"
      prev-icon="fa-chevron-left"
      next-icon="fa-chevron-right"
    />
  </div>
</template>

<script>
import gql from "graphql-tag";
import jobVariants from "@/data/enums/JobVariant.js";

export default {
  props: {
    projectId: { type: String, required: true }
  },
  data() {
    return {
      jobVariants,
      saveInterval: null,
      fetchFailed: false,
      currentPage: 1
    };
  },
  apollo: {
    vacancyPage: {
      query: gql`
        query VacancyPage($page: Int, $filter: VacancyFilter) {
          vacancyPage(page: $page, filter: $filter) {
            results {
              id
              title
              number
            }
            total
          }
        }
      `,
      result(data) {
        if (!this.$route.params.jobid && data.data.vacancyPage.results.length) {
          this.$router.replace({
            name: "project.edit.sub.job",
            params: { page: "jobs", jobid: data.data.vacancyPage.results[0].id }
          });
        }
        return data.data.vacancyPage;
      },
      variables() {
        return {
          page: this.currentPage,
          filter: {
            project: this.projectId
          }
        };
      }
    }
  },
  computed: {
    totalPages() {
      return this.vacancyPage ? Math.ceil(this.vacancyPage.total / 15) : null;
    }
  },
  mounted() {
    this.$apollo.queries.vacancyPage.refetch();
  },
  methods: {
    updateValue() {}
  }
};
</script>
